module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc2-03-ebe86129a73eda4df88a548a35e56298.png";